export type CalendarAuthErrorTranslationKey =
  | 'authErrorMissingSession'
  | 'authErrorStateMismatch'
  | 'authErrorRedirectMismatch'
  | 'authErrorTokenExchange'
  | 'authErrorLinkedElsewhere'
  | 'authErrorGeneric'

export const calendarAuthErrorTranslations: Record<
  'de' | 'en',
  Record<CalendarAuthErrorTranslationKey, string>
> = {
  en: {
    authErrorMissingSession:
      'Calendar connection expired during sign-in. Please start the connection again.',
    authErrorStateMismatch:
      'Calendar connection could not be verified. Please try connecting the account again.',
    authErrorRedirectMismatch:
      'Calendar connection returned to the wrong address. Please try again.',
    authErrorTokenExchange:
      'Calendar sign-in completed, but Jupus could not finish the connection. Please try again.',
    authErrorLinkedElsewhere: 'This calendar account is already connected in another organisation.',
    authErrorGeneric: 'Calendar connection failed. Please try again.'
  },
  de: {
    authErrorMissingSession:
      'Die Kalender-Verbindung ist während der Anmeldung abgelaufen. Bitte starten Sie die Verbindung erneut.',
    authErrorStateMismatch:
      'Die Kalender-Verbindung konnte nicht verifiziert werden. Bitte versuchen Sie es erneut.',
    authErrorRedirectMismatch:
      'Die Kalender-Verbindung ist auf einer falschen Adresse gelandet. Bitte versuchen Sie es erneut.',
    authErrorTokenExchange:
      'Die Anmeldung wurde abgeschlossen, aber Jupus konnte die Verbindung nicht finalisieren. Bitte versuchen Sie es erneut.',
    authErrorLinkedElsewhere:
      'Dieses Kalender-Konto ist bereits mit einer anderen Organisation verbunden.',
    authErrorGeneric: 'Die Kalender-Verbindung ist fehlgeschlagen. Bitte versuchen Sie es erneut.'
  }
}

export const getCalendarAuthErrorMessage = (
  value: unknown,
  t: (key: CalendarAuthErrorTranslationKey) => string
): string | null => {
  switch (value) {
    case 'missing_session_state':
      return t('authErrorMissingSession')
    case 'state_mismatch':
      return t('authErrorStateMismatch')
    case 'redirect_uri_mismatch':
      return t('authErrorRedirectMismatch')
    case 'token_exchange_failed':
      return t('authErrorTokenExchange')
    case 'account_linked_elsewhere':
      return t('authErrorLinkedElsewhere')
    case 'missing_code_state':
      return t('authErrorGeneric')
    default:
      return value ? t('authErrorGeneric') : null
  }
}
